<template>
  <div class="products">
    <div class="banner-box" id="home" ref="home">
      <menuBox :step="4"></menuBox>
      <div class="banner-text">
        <div class="title">Produk Kami</div>
      </div>
    </div>
    
    <!-- 应用介绍部分 -->
    <div class="apps-container">
      <!-- SolusiUang 应用 -->
      <div class="app-intro-box">
        <div class="app-header">
          <div class="app-logo">
            <img src="../assets/SolusiUang.png" alt="SolusiUang Logo" class="logo-img">
          </div>
          <div class="app-info">
            <h2 class="app-name">SolusiUang - Online Financial Manager</h2>
            <p class="app-description">Bantu pengguna merekomendasikan produk pinjaman berkualitas tinggi</p>
          </div>
        </div>
        
        <div class="app-images">
          <div class="app-image-placeholder">
           <img src="../assets/1.png" alt="SolusiUang Screenshot 1">
          </div>
          <div class="app-image-placeholder">
            <img src="../assets/2.png" alt="SolusiUang Screenshot 2">
          </div>
          <div class="app-image-placeholder">
            <img src="../assets/3.png" alt="SolusiUang Screenshot 3">
          </div>
          <div class="app-image-placeholder">
            <img src="../assets/4.png" alt="SolusiUang Screenshot 4">
          </div>
        </div>
        
        <div class="app-detail">
          <div class="app-long-description">
            <p>SolusiUang berfokus pada rekomendasi produk pinjaman berkualitas tinggi kepada pengguna, menyesuaikan solusi layanan keuangan yang sesuai untuk Anda, dan memfasilitasi pengguna untuk menyelesaikan masalah keuangan dengan cepat. Semua jumlah pinjaman dan produk keuangan SolusiUang berasal dari lembaga P2P yang bekerja sama.</p>
            
            <p>Aplikasi ini merekomendasikan produk keuangan kepada pengguna sebagai platform, dan platform ini tidak menjamin apakah pinjaman tersebut dapat disetujui. Kami berkomitmen untuk memberikan layanan terbaik dalam membantu Anda menemukan solusi keuangan yang tepat.</p>
          </div>
          
          <div class="app-features">
            <h3>Ⅰ. Fitur Utama SolusiUang:</h3>
            <ul class="features-list">
              <li><strong>Pencocokan Cerdas</strong> - Mencocokkan produk pinjaman yang tepat secara akurat berdasarkan kebutuhan Anda.</li>
              <li><strong>Operasi Sederhana</strong> - Klik untuk mengunduh aplikasi keuangan dari Google Play Store.</li>
              <li><strong>Beragam Produk</strong> - Konsolidasikan produk pinjaman dari berbagai lembaga keuangan.</li>
              <li><strong>Transparansi Penuh</strong> - Seluruh proses transparan, tanpa biaya tersembunyi.</li>
              <li><strong>Proses Cepat</strong> - Rekomendasi produk pinjaman dalam hitungan menit.</li>
              <li><strong>Keamanan Terjamin</strong> - Kerjasama hanya dengan lembaga P2P terpercaya dan berlisensi.</li>
            </ul>
          </div>
          
          <div class="app-usage">
            <h3>II. Cara Menggunakan SolusiUang:</h3>
            <div class="usage-steps">
              <div class="usage-item">
                <strong>Unduh Aplikasi:</strong> Download SolusiUang dari Google Play Store dan lakukan registrasi sederhana.
              </div>
              <div class="usage-item">
                <strong>Isi Profil:</strong> Lengkapi informasi dasar Anda untuk mendapatkan rekomendasi yang tepat.
              </div>
              <div class="usage-item">
                <strong>Dapatkan Rekomendasi:</strong> Sistem akan merekomendasikan produk pinjaman yang sesuai dengan kebutuhan Anda.
              </div>
            </div>
          </div>
          
          <div class="app-advantages">
            <h3>III. Mengapa Memilih SolusiUang?</h3>
            <div class="advantages-grid">
              <div class="advantage-item">
                <h4>Rekomendasi Akurat</h4>
                <p>Algoritma cerdas yang mencocokkan kebutuhan Anda dengan produk pinjaman yang tepat.</p>
              </div>
              <div class="advantage-item">
                <h4>Proses Mudah</h4>
                <p>Interface yang user-friendly memudahkan Anda menemukan dan mengakses produk keuangan.</p>
              </div>
              <div class="advantage-item">
                <h4>Partner Terpercaya</h4>
                <p>Bekerjasama hanya dengan lembaga P2P yang memiliki izin dan reputasi baik.</p>
              </div>
              <div class="advantage-item">
                <h4>Tanpa Biaya Tersembunyi</h4>
                <p>Semua informasi biaya dan syarat ditampilkan secara transparan.</p>
              </div>
              <div class="advantage-item">
                <h4>Layanan Gratis</h4>
                <p>Aplikasi SolusiUang dapat digunakan secara gratis tanpa biaya berlangganan.</p>
              </div>
              <div class="advantage-item">
                <h4>Dukungan 24/7</h4>
                <p>Tim customer service siap membantu Anda kapan saja dibutuhkan.</p>
              </div>
            </div>
          </div>
          
          <div class="app-disclaimer">
            <p>SolusiUang adalah platform rekomendasi yang menghubungkan pengguna dengan berbagai lembaga keuangan P2P berlisensi. Kami tidak menjamin persetujuan pinjaman karena keputusan akhir tetap berada di tangan masing-masing lembaga keuangan.</p>
            
            <p><strong>Anda harus berusia minimal 18 tahun dan memiliki KTP yang valid untuk menggunakan layanan ini.</strong></p>
            
            <p>Kami berkomitmen membantu Anda menemukan solusi keuangan yang tepat dengan cara yang aman, transparan, dan bertanggung jawab.</p>
          </div>
          
          <div class="app-contact">
            <h3>IV. Hubungi Kami</h3>
            <p>Jika Anda memiliki pertanyaan atau membutuhkan bantuan, jangan ragu untuk menghubungi kami.</p>
            <div class="contact-details">
              <div class="contact-item">
                <strong>Jam Operasional:</strong> Senin hingga Minggu, 9:00 - 18:00 WIB.
              </div>
              <div class="contact-item">
                <strong>Email:</strong> cs@ptdaniswarateknologi.com
              </div>
              <div class="contact-item">
                <strong>Website Resmi:</strong> https://ptdaniswarateknologi.com/
              </div>
              <div class="contact-item">
                <strong>Alamat:</strong> Graha Mampang Lt.3 suite 305, Jl. Mampang Prpt. Raya No.KAV.100, Desa/Kelurahan Duren Tiga, Kec. Pancoran, Kota Adm. Jakarta Selatan, Provinsi DKI Jakarta, Kode Pos: 12760.
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CreditScan 应用 -->
      <div class="app-intro-box creditscan-app">
        <div class="app-header">
          <div class="app-logo">
            <img src="../assets/CreditScan.png" alt="CreditScan Logo" class="logo-img">
          </div>
          <div class="app-info">
            <h2 class="app-name">CreditScan-Senior Helpers</h2>
            <p class="app-description">Quickly check your credit health with one click!</p>
          </div>
        </div>
        
        <div class="app-images">
          <div class="app-image-placeholder">
           <img src="../assets/app-1.png" alt="CreditScan Screenshot 1">
          </div>
          <div class="app-image-placeholder">
            <img src="../assets/app-2.png" alt="CreditScan Screenshot 2">
          </div>
          <div class="app-image-placeholder">
            <img src="../assets/app-3.png" alt="CreditScan Screenshot 3">
          </div>
          <div class="app-image-placeholder">
            <img src="../assets/app-4.png" alt="CreditScan Screenshot 4">
          </div>
        </div>
        
        <div class="app-detail">
          <div class="app-long-description">
            <p>CreditScan is a professional credit assessment tool that provides users with fast, accurate, and reliable personal credit analysis services. Leveraging big data and intelligent algorithms, we comprehensively assess your financial situation, repayment history, and behavioral characteristics, helping you gain a clear understanding of your credit profile, ensuring a smoother and more efficient loan approval process.</p>
            
            <p>Whether you're interested in understanding your personal credit status or preparing for a loan application, CreditScan provides objective and reliable data support, making it your reliable credit management partner.</p>
          </div>
          
          <div class="app-features">
            <h3>Ⅰ. CreditScan's key features include:</h3>
            <ul class="features-list">
              <li><strong>Intelligent Assessment</strong> - Generates a personalized credit score using AI algorithms combined with multi-dimensional data.</li>
              <li><strong>Quick Query</strong> - View your personal credit results in minutes.</li>
              <li><strong>Data Transparency</strong> - Clearly displays your credit profile and risk level, providing a clear overview of your credit status.</li>
              <li><strong>Security and Compliance</strong> - Advanced data encryption technology is used to strictly protect user information.</li>
              <li><strong>Credit Improvement Recommendations</strong> - Provides personalized credit optimization suggestions based on analysis results to help you improve your credit rating.</li>
              <li><strong>Loan Assisted Matching</strong> - Optional feature: Intelligently recommends suitable loan products based on the assessment results.</li>
            </ul>
          </div>
          
          <div class="app-usage">
            <h3>II. How to Use?</h3>
            <div class="usage-steps">
              <div class="usage-item">
                <strong>Registration:</strong> A simple registration process allows you to begin analyzing all your financial records and behaviors.
              </div>
              <div class="usage-item">
                <strong>Data Security:</strong> We ensure the security of all your data and use it only with your consent.
              </div>
              <div class="usage-item">
                <strong>Customized Recommendations:</strong> We analyze your current credit score and financial behavior to provide you with personalized credit improvement recommendations.
              </div>
            </div>
          </div>
          
          <div class="app-advantages">
            <h3>III. Why Choose CreditScan?</h3>
            <div class="advantages-grid">
              <div class="advantage-item">
                <h4>Data Security and Encryption</h4>
                <p>Multi-layered information technology helps protect user data and ensures the security of your information at all times.</p>
              </div>
              <div class="advantage-item">
                <h4>Real-Time Credit Check</h4>
                <p>Users can check their credit scores at any time without having to wait for bank or third-party reports.</p>
              </div>
              <div class="advantage-item">
                <h4>Personalized Improvement Recommendations</h4>
                <p>We provide personalized credit improvement recommendations based on their credit scores.</p>
              </div>
              <div class="advantage-item">
                <h4>Easy to Use</h4>
                <p>The user-friendly interface allows you to quickly register and check your credit score with just your phone number or ID card.</p>
              </div>
              <div class="advantage-item">
                <h4>Free and Secure</h4>
                <p>We provide free credit assessment services and strictly protect user privacy.</p>
              </div>
              <div class="advantage-item">
                <h4>Increase Loan Success Rate</h4>
                <p>Users with high credit scores are more likely to qualify for loans or installment loans.</p>
              </div>
            </div>
          </div>
          
          <div class="app-disclaimer">
            <p>It's important to understand that CreditScan is an independently operated platform and has no affiliation with any bank or licensed lender. The information we collect is used solely for credit assessment and service improvement, and we promise not to sell, disclose, or share it with any unrelated third parties. To ensure the legality and security of information processing, we only partner with necessary service providers for data analysis and security verification.</p>
            
            <p><strong>You must be at least 18 years of age to use the credit analysis feature of this platform.</strong></p>
            
            <p>We're committed to helping you gain a clearer understanding of your credit status. Whether you're considering a loan, looking to increase your credit limit, or simply want a comprehensive overview of your personal credit health, CreditScan provides you with professional, reliable data support and reference.</p>
          </div>
          
          <div class="app-contact">
            <h3>IV. Contact Us</h3>
            <p>If you have any questions during use, please contact us.</p>
            <div class="contact-details">
              <div class="contact-item">
                <strong>Business Hours:</strong> Monday to Saturday, 9:30 AM to 6:30 PM.
              </div>
              <div class="contact-item">
                <strong>Email:</strong> cs@ptdaniswarateknologi.com
              </div>
              <div class="contact-item">
                <strong>Official website:</strong> https://ptdaniswarateknologi.com/
              </div>
              <div class="contact-item">
                <strong>Address:</strong> Graha Mampang Lt.3 suite 305, Jl. Mampang Prpt. Raya No.KAV.100, Desa/Kelurahan Duren Tiga, Kec. Pancoran, Kota Adm. Jakarta Selatan, Provinsi DKI Jakarta, Kode Pos: 12760.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerBox></footerBox>
  </div>
</template>

<script>
  import footerBox from "@/components/footer";
  import menuBox from "@/components/menu";

  export default {
    name: "Products",
    components: {
      menuBox,
      footerBox,
    },
    data() {
      return {};
    },
    mounted() { },
    methods: {},
  };
</script>

<style lang="less" scoped>
  .banner-box {
    background-image: url(../assets/swiper-3.png);
    height: 620px;
    background-size: 100% 100%;

    .banner-text {
      margin: 0 360px;
      padding-top: 100px;
      text-align: left;
      margin-top: 100px;

      .title {
        font-family: HelveticaNeue, HelveticaNeue;
        font-weight: bold;
        font-size: 80px;
        color: #333333;
      }
    }
  }

  .apps-container {
    background: #FFFFFF;
  }

  .app-intro-box {
    padding: 80px 360px;
    border-bottom: 1px solid #E5E5E5;
    
    &:last-child {
      border-bottom: none;
    }
    
    &.creditscan-app {
      background: #F8F9FA;
    }

    .app-header {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      padding-bottom: 30px;
      border-bottom: 2px solid #F42D41;

      .app-logo {
        margin-right: 30px;
        
        .logo-img {
          width: 80px;
          height: 80px;
          border-radius: 15px;
          box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
        }
      }

      .app-info {
        flex: 1;

        .app-name {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 32px;
          color: #333333;
          margin-bottom: 10px;
        }

        .app-description {
          font-family: HelveticaNeue;
          font-size: 18px;
          color: #666666;
          line-height: 1.6;
          margin: 0;
        }
      }
    }

    .app-images {
      display: flex;
      gap: 20px;
      margin-bottom: 40px;
      justify-content: center;

      .app-image-placeholder {
        width: 180px;
        height: 320px;
        border-radius: 15px;
        overflow: hidden;
        box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        
        &:hover {
          transform: translateY(-5px);
          box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2);
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .app-detail {
      .app-long-description {
        margin-bottom: 40px;
        
        p {
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #333333;
          line-height: 1.8;
          margin-bottom: 20px;
        }
      }
      
      .app-features,
      .app-usage,
      .app-advantages,
      .app-disclaimer,
      .app-contact {
        margin-bottom: 40px;
        
        h3 {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 24px;
          color: #F42D41;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid #E5E5E5;
        }
        
        p {
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #333333;
          line-height: 1.8;
          margin-bottom: 15px;
        }
      }
      
      .features-list {
        list-style: none;
        padding: 0;
        
        li {
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #333333;
          line-height: 1.8;
          margin-bottom: 15px;
          padding-left: 20px;
          position: relative;
          
          &:before {
            content: "✓";
            position: absolute;
            left: 0;
            color: #F42D41;
            font-weight: bold;
          }
          
          strong {
            color: #F42D41;
          }
        }
      }
      
      .usage-steps {
        .usage-item {
          background: #FFFFFF;
          padding: 20px;
          border-radius: 10px;
          margin-bottom: 15px;
          box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #333333;
          line-height: 1.6;
          
          strong {
            color: #F42D41;
          }
        }
      }
      
      .advantages-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 25px;
        
        .advantage-item {
          background: #FFFFFF;
          padding: 25px;
          border-radius: 12px;
          box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          
          &:hover {
            transform: translateY(-3px);
            box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.15);
          }
          
          h4 {
            font-family: HelveticaNeue, HelveticaNeue;
            font-weight: bold;
            font-size: 18px;
            color: #F42D41;
            margin-bottom: 10px;
          }
          
          p {
            font-family: HelveticaNeue;
            font-size: 14px;
            color: #666666;
            line-height: 1.6;
            margin: 0;
          }
        }
      }
      
      .app-disclaimer {
        background: #FFF9E6;
        padding: 25px;
        border-radius: 10px;
        border-left: 4px solid #F42D41;
        
        p {
          margin-bottom: 15px;
          
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      
      .contact-details {
        background: #FFFFFF;
        padding: 25px;
        border-radius: 10px;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
        
        .contact-item {
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #333333;
          margin-bottom: 15px;
          line-height: 1.6;
          
          &:last-child {
            margin-bottom: 0;
          }
          
          strong {
            color: #F42D41;
          }
        }
      }

      p {
        font-family: HelveticaNeue;
        font-size: 16px;
        color: #333333;
        line-height: 1.8;
      }
    }
  }

  .loan-intro-box,
  .eligibility-box,
  .loan-features-box,
  .loan-calculation-box,
  .privacy-box,
  .contact-box {
    padding: 80px 360px;

    &:nth-child(even) {
      background: #ECF1FA;
    }

    .section-title {
      margin-bottom: 40px;

      h3 {
        font-family: HelveticaNeue, HelveticaNeue;
        font-weight: bold;
        font-size: 32px;
        color: #333333;
      }
    }

    .section-content {
      p {
        font-family: HelveticaNeue;
        font-size: 18px;
        color: #333333;
        line-height: 1.8;
        margin-bottom: 20px;
      }
    }
  }

  .feature-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-top: 30px;

    .feature-item {
      display: flex;
      align-items: flex-start;

      .feature-number {
        width: 40px;
        height: 40px;
        background: #F42D41;
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        margin-right: 20px;
        flex-shrink: 0;
      }

      .feature-content {
        h4 {
          font-family: HelveticaNeue, HelveticaNeue;
          font-weight: bold;
          font-size: 20px;
          color: #333333;
          margin-bottom: 10px;
        }

        p {
          font-family: HelveticaNeue;
          font-size: 16px;
          color: #666666;
          line-height: 1.6;
          margin: 0;
        }
      }
    }
  }

  .eligibility-list {
    .eligibility-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;

      .eligibility-number {
        width: 30px;
        height: 30px;
        background: #F42D41;
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        margin-right: 20px;
        flex-shrink: 0;
      }

      p {
        font-family: HelveticaNeue;
        font-size: 18px;
        color: #333333;
        line-height: 1.6;
        margin: 0;
      }
    }
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;

    .feature-card {
      background: #FFFFFF;
      padding: 30px;
      border-radius: 10px;
      box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1);

      h4 {
        font-family: HelveticaNeue, HelveticaNeue;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
        margin-bottom: 15px;
      }

      p {
        font-family: HelveticaNeue;
        font-size: 16px;
        color: #666666;
        line-height: 1.6;
        margin: 0;
      }
    }
  }

  .calculation-info {
    margin-bottom: 30px;

    p {
      margin-bottom: 15px;
    }
  }

  .calculation-example {
    background: #f8f9fa;
    padding: 30px;
    border-radius: 10px;

    h4 {
      font-family: HelveticaNeue, HelveticaNeue;
      font-weight: bold;
      font-size: 24px;
      color: #333333;
      margin-bottom: 20px;
    }

    .calculation-formula {
      background: #FFFFFF;
      padding: 20px;
      border-radius: 8px;
      margin: 20px 0;

      .formula-item {
        font-family: HelveticaNeue;
        font-size: 16px;
        color: #333333;
        margin-bottom: 10px;
        padding: 10px;
        background: #f8f9fa;
        border-radius: 5px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .calculation-note {
      font-family: HelveticaNeue;
      font-size: 16px;
      color: #666666;
      line-height: 1.6;
      font-style: italic;
      margin-top: 20px;
    }
  }

  .contact-info {
    .contact-item {
      font-family: HelveticaNeue;
      font-size: 18px;
      color: #333333;
      margin-bottom: 15px;
      line-height: 1.6;

      strong {
        color: #F42D41;
      }
    }
  }

  /* 响应式设计 */
  @media (max-width: 1200px) {
    .app-intro-box {
      padding: 60px 200px;
    }
    
    .banner-box .banner-text {
      margin: 0 200px;
    }
    
    .loan-intro-box,
    .eligibility-box,
    .loan-features-box,
    .loan-calculation-box,
    .privacy-box,
    .contact-box {
      padding: 60px 200px;
    }
  }

  @media (max-width: 768px) {
    .banner-box {
      height: 400px;
      
      .banner-text {
        margin: 0 20px;
        padding-top: 60px;
        margin-top: 60px;
        
        .title {
          font-size: 48px;
        }
      }
    }
    
    .app-intro-box {
      padding: 40px 20px;
      
      .app-header {
        flex-direction: column;
        text-align: center;
        
        .app-logo {
          margin-right: 0;
          margin-bottom: 20px;
        }
        
        .app-info {
          .app-name {
            font-size: 24px;
          }
          
          .app-description {
            font-size: 16px;
          }
        }
      }
      
      .app-images {
        flex-wrap: wrap;
        gap: 15px;
        
        .app-image-placeholder {
          width: calc(50% - 7.5px);
          height: 280px;
        }
      }

      .app-detail {
        .advantages-grid {
          grid-template-columns: 1fr;
          gap: 20px;
        }
        
        .app-features h3,
        .app-usage h3,
        .app-advantages h3,
        .app-contact h3 {
          font-size: 20px;
        }
      }
    }
    
    .loan-intro-box,
    .eligibility-box,
    .loan-features-box,
    .loan-calculation-box,
    .privacy-box,
    .contact-box {
      padding: 40px 20px;
      
      .section-title h3 {
        font-size: 24px;
      }
      
      .features-grid {
        grid-template-columns: 1fr;
      }
      
      .feature-list {
        grid-template-columns: 1fr;
      }
    }
  }

  @media (max-width: 480px) {
    .banner-box .banner-text .title {
      font-size: 36px;
    }
    
    .app-intro-box {
      .app-header {
        .app-info .app-name {
          font-size: 20px;
        }
      }
      
      .app-images {
        .app-image-placeholder {
          width: 100%;
          height: 300px;
        }
      }
    }
  }
</style>
